// extracted by mini-css-extract-plugin
export default {"adjacentVendors":"adjacentVendors__ZTZhN","adjacentVendorCard":"adjacentVendorCard__Mzg4M"};